module.exports = __webpack_public_path__ + "img/AIO5000_aodo_1-1.aacc964d.jpg";